import { colors, Stack } from '@ui-components/neo.tax';
import { useState } from 'react';

import { type AscProject } from '@neo.tax/asc/hooks';
import { PeriodName } from '@neo.tax/shared';

import { CapitalizationEditModal } from '../capitalization-edit-modal';
import { CellContainer, EditButton, StatusDot, StatusText } from './asc-project-capitalized-cell.styled';

export type AscProjectCapitalizedCellProps = {
  ascProject: AscProject;
  fiscalYearId: string;
  periodName: PeriodName;
};

export const AscProjectCapitalizedCell = ({ ascProject }: AscProjectCapitalizedCellProps): React.ReactElement => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      <CellContainer
        direction="row"
        gap={1.5}
        alignItems="center"
        onMouseEnter={(): void => setIsHovered(true)}
        onMouseLeave={(): void => setIsHovered(false)}
      >
        <Stack direction="row" gap={1} alignItems="center">
          <StatusDot $isCapitalized={ascProject.isCapitalized} />
          <StatusText fontSize="sm" $isCapitalized={ascProject.isCapitalized}>
            {ascProject.isCapitalized ? 'Yes' : '—'}
          </StatusText>
        </Stack>
        <EditButton
          as="button"
          fontSize="xs"
          color={colors.gray[400]}
          $isVisible={isHovered}
          onClick={(e: React.MouseEvent): void => {
            e.stopPropagation();
            setIsModalOpen(true);
          }}
        >
          Edit
        </EditButton>
      </CellContainer>
      <CapitalizationEditModal
        isOpen={isModalOpen}
        onClose={(): void => setIsModalOpen(false)}
        ascProjectId={ascProject.id}
      />
    </>
  );
};
